var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:['hero', _vm.name],style:(_vm.style)},_vm.$listeners),[(_vm.disabled)?_c('div',{staticClass:"disabled"},[_c('Icon',{attrs:{"name":"lock"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }